<div
    *ngIf="visible$ | async"
    class="flex items-center gap-2.5 border-b border-teal-200 bg-teal-50 px-4 py-2 text-sm text-teal-900 md:px-6 print:hidden"
    role="status"
    data-testid="client-view-strip"
>
    <mat-icon class="icon-size-4 flex-shrink-0 text-current" [svgIcon]="'heroicons_outline:eye'"></mat-icon>
    <span class="min-w-0 flex-1">
        <b>{{ "clientView.strip_title" | transloco }}</b>
        {{ "clientView.strip_body" | transloco }}
    </span>
    <button
        type="button"
        class="flex-shrink-0 font-bold underline"
        data-testid="client-view-back"
        (click)="backToInternal()"
    >
        {{ "clientView.back" | transloco }}
    </button>
</div>
